module.exports = __webpack_public_path__ + "img/volcano_small.c6771496.png";